import { useMsal } from "@azure/msal-react";
import { RENEWAL_FAILED_MESSAGE } from "@scheduler/shared";

import { apiScope, loginRequest } from "./auth/config";
import { useRenewalFailed } from "./auth/renewal";
import { rememberReturnPath } from "./router";

/**
 * Shown once this tab's sign-in could not be renewed (punch list F197): a
 * real sign-in, one press away. It replaces "Please reload the page and sign
 * in again", which did not work: a reload keeps the tab's flag, so the app
 * went on refusing. The sign-in coming back clears the flag (`main.tsx`).
 *
 * The update bar's place and shape, above it if both are up: this one matters
 * more, and the sign-in reloads the page onto the newer build anyway.
 */
export function SignInAgainBar() {
  const { instance, accounts } = useMsal();
  const lost = useRenewalFailed();
  if (!lost) return null;
  return (
    <div className="update-bar sign-in-lost" role="alert">
      <span>{RENEWAL_FAILED_MESSAGE}</span>
      <button
        type="button"
        className="primary narrow"
        onClick={() => {
          // Back to the screen they were on, as every sign-in does.
          rememberReturnPath();
          const account = accounts[0];
          void (account
            ? instance.acquireTokenRedirect({ scopes: [apiScope], account })
            : instance.loginRedirect(loginRequest));
        }}
      >
        Sign in again
      </button>
    </div>
  );
}
